import map1 from './imgs/footprint1.jpg';
import map2 from './imgs/footprint2.jpg';
import map3 from './imgs/footprint3.jpg';
import './index.css';
const Maps = () => {
    return <div className='maps'>
        <img src={map1} alt="map" className='map'/>
        <img src={map2} alt="map" className='map'/>
        <img src={map3} alt="map" className='map'/>
    </div>
}

export default Maps;